import React, { useState, useEffect } from 'react'
import { useRunAdminProcedureMutation } from '../Redux/Admin_Tasks/AdminProcedureSlice'
import { getBaseUrl } from '../Utils';
import { useRunAdminToolsMutation } from '../Redux/Admin_Tasks/AdminProcedureSlice'
import DatePicker from '../Components/DatePicker/DatePicker'
import moment from 'moment'

import { Skeleton } from '../GenericComponents/Skeleton'
import { FoundationsEnums } from '../enum';
import { FoundationsGenericToaster } from '../GenericComponents/FoundationsGenericToaster';
import { useTitleContext } from "../Hooks/useTitleContext";
import { Link } from 'react-router-dom';


declare let window: any
const UnicornApp = window.unicornInstance as any
type isChecked = {
    [key: number]: boolean
}
interface request {
    AdminTool: any
}
interface ParamListItem {
    Position: number
    _DataType: string
}
interface isCheckedVal {
    val: number
}
interface TableData {
    Columns: string[]
    Rows: Array<Record<string, any>>
}

interface ResultTable {
    [key: string]: {
        [key: string]: TableData
    }
}

const RunAdminProcedure: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Data Sources");

    const [GuidValue, setGuidValue] = useState<string | null>(null)
    const [isChecked, setIsChecked] = useState<{ [key: number]: boolean }>({})
    const [checkAll, setCheckAll] = useState(false)
    const [paramValues, setParamValues] = useState<Record<number, string | number>>({});
    const [ChecckBoxValuefield, SetChecckBoxValuefield] = useState<{ [key: number]: isCheckedVal }>(
        {}
    )
    const updatedParamValues: any = {}
    const [runAdminProcedure, resultdata] = useRunAdminProcedureMutation()

    const { data, isLoading } = resultdata as {
        data: {
            ToolSPName: string
            ToolDescription: string
            ParamList: any[]
        }
        error: unknown
        isLoading: boolean
    }
    useEffect(() => {
        const hash = window.location.hash
        const queryIndex = hash.indexOf('?')
        if (queryIndex !== -1) {
            const queryString = hash.substring(queryIndex + 1)
            const queryParams = new URLSearchParams(queryString)
            const guidFromUrl = queryParams.get('Guid')
            setGuidValue(guidFromUrl)
        }
    }, [])

    useEffect(() => {
        if (GuidValue) {
            runAdminProcedure({ Guid: GuidValue })
                .unwrap()
                .catch((apiError) => {
                    console.error('API call error: ', apiError)
                })
        }
    }, [GuidValue, runAdminProcedure])
    const handleInputChange = (index: any, value: any, isCheckbox: boolean = false) => {
        setParamValues((prev) => ({
            ...prev,
            [index]: isCheckbox ? (value ? 1 : 0) : value,
        }))
        if (isCheckbox) {
            SetChecckBoxValuefield(value)
        }
    }

    const handleCheckboxChange = (position: number) => {
        setIsChecked((prevState) => {
            const updatedCheckedItems = {
                ...prevState,
                [position]: !prevState[position],
            }

            const isAnyUnchecked = Object.values(updatedCheckedItems).some((checked) => !checked)
            if (isAnyUnchecked) {
                setCheckAll(false)
            }
            return updatedCheckedItems
        })
    }

    const handleCheckAll = () => {
        const updatedCheckedItems: isChecked = {}
        if (data?.ParamList) {
            data.ParamList.forEach((item: ParamListItem) => {
                updatedCheckedItems[item.Position] = true
            })

            setIsChecked(updatedCheckedItems)
            setCheckAll(true)
        }
    }

    const handleUncheckAll = () => {
        const updatedCheckedItems: isChecked = {}
        const updatedParamValues: any = {}
        data.ParamList.forEach((item) => {
            if (item._DataType === 'bit') {
                updatedCheckedItems[item.Position] = false;
                updatedParamValues[item.Position] = 0; 
            } 
            else {
                updatedParamValues[item.Position] = paramValues[item.Position];
            }
        });

        setIsChecked(updatedCheckedItems)
        setParamValues(updatedParamValues)
        setCheckAll(false)
    }

    let Request: request = { AdminTool: null }
    const [runAdminTools, {}] = useRunAdminToolsMutation()
    const [resultHtml, setResultHtml] = useState<ResultTable | null>(null)
    const [startingDates, setStartingDates] = useState<{ [key: number]: string }>({});
    let handleRun = async (request: request) => {
        request.AdminTool = data
        request.AdminTool = { ...request.AdminTool }
        const updatedParamList = request.AdminTool.ParamList.map((param: any, i: number) => {
            const index = i + 1
            const paramValue = paramValues[index] || ''
            const isNull = isChecked[i + 1] || false

            const updatedParam = {
                ...param,
                IsNull: isNull,
            }
            if (param._DataType === 'bit') {
                updatedParam.Value = ChecckBoxValuefield
            } else if (paramValue !== '') {
                updatedParam.Value = paramValue
            }else if (param.DataType === FoundationsEnums.HLDataType.HLAge) {      // FP-10623 Check if the date exists in startingDates for the corresponding param position
                updatedParam.Value = startingDates[param.Position] || '';
            } 
            else {
                delete updatedParam.Value
            }

            return updatedParam
        })
        request.AdminTool.ParamList = updatedParamList
        const response = await runAdminTools(request).unwrap()
        try {
            if (response) {
                const updatedParamVal: any = {}
                setResultHtml(null)
                const resultData = response
                if (resultData?.MessageResults?.length > 0) {
                    for (let i = 0; i < resultData.MessageResults.length; i++) {
                        const messageResult = resultData.MessageResults[i]
                        if (messageResult.HelpMessage === 0) {
                            if (response.resultTable !== '') {
                                const Newdata = response.resultTable

                                data.ParamList.forEach((item: any) => {
                                    updatedParamVal[item.Position] = ''
                                })
                                setResultHtml(Newdata)
                                setParamValues(updatedParamVal)
                            }

                            FoundationsGenericToaster('success', messageResult.Message)
                        } else {
                            FoundationsGenericToaster(
                                'error',
                                `${resultData.MessageResults[i].Field.replace('@', '')} ${resultData.MessageResults[i].Message}`
                            )
                        }
                    }
                }
                // Reset the startingDates after Run action
                setStartingDates({});
            }
        } catch (error) {
            console.error('Error running tool:', error)
            FoundationsGenericToaster('error', 'Something went wrong with the API call.')
        }
    }
    const handleDateChange = (position: number, newDate: string) => {
        setStartingDates((prev) => ({
            ...prev,
            [position]: newDate,
        }));
    };

    const renderCell = (cellValue: any) => {
        if (typeof cellValue === 'object' && cellValue !== null) {
            return Object.keys(cellValue).length === 0 ? '' : JSON.stringify(cellValue);
        }
        // Handle boolean values directly FP-10478
        if (typeof cellValue === 'boolean') {
            return cellValue ? 'True' : 'False';
        }
        // If the content has HTML tags (e.g., <br />), render it as HTML FP-10809
        if (typeof cellValue === 'string') { 
            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: cellValue.replace(/<\/?br\s*\/?>/g, "<br />"), 
                    }}
                />
            );
        }

        return cellValue && cellValue.length === 0 ? '' : cellValue || '';
    }

    const renderRows = (rows: any[], columns: string[]) => {
        return rows.map((row, rowIndex) => (
            <tr className="admin-row-data" key={rowIndex}>
                {columns.map((column, colIndex) => (
                    <td key={colIndex}>{renderCell(row[column])}</td>
                ))}
            </tr>
        ))
    }

    const renderHeaders = (columns: string[]) => {
        return (
            <thead>
                <tr className="admin-row-header">
                    {columns.map((column, colIndex) => (
                        <td key={colIndex}>{column}</td>
                    ))}
                </tr>
            </thead>
        )
    }

    const renderTable = (tableData: any) => {
        return Object.keys(tableData).map((subTableKey) => (
            <div key={subTableKey} className="admin-table-wrapper" style={{ marginTop: '20px' }}>
                <table className="admin-table">
                    {renderHeaders(tableData[subTableKey].Columns)}
                    <tbody>
                        {renderRows(tableData[subTableKey].Rows, tableData[subTableKey].Columns)}
                    </tbody>
                </table>
            </div>
        ))
    }
    const handleCancel = () => {
        window.location.href = window.baseURL + '/ux/index.html#ManageAdminTools'
    }
    if (isLoading)
        return (
            <Skeleton loading ={isLoading} height = '50px' width='100%'>
                
            </Skeleton>
        )
    else {
        if (data) {
            return (
                <>
                    <div>
                        <div className="include-bootstrap" id="adminTool-manager">
                            <div className="">
                                <div className="content">
                                    <div className="float-right margin-top-small">
                                        <a
                                            id="link_backto_admin_tasks"
                                            href="#AdminTasks"
                                        >
                                            &laquo; Back to Admin Tasks
                                        </a>
                                    </div>
                                    <div className="header">Manage Admin Procedures</div>
                                </div>
                            </div>
                        </div>

                        <div className="row d-block">
                            <div className="">
                                <div className="content">
                                    <div className="float-right margin-top-small">
                                        <Link
                                            id="link_backto_admin_procedure"
                                            to="#ManageAdminTools"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            &laquo; Back to Admin Procedures
                                        </Link>
                                    </div>
                                    <h3
                                        className="fw-normal"
                                        style={{ marginLeft: '15px', fontSize: '18px' }}
                                    >
                                        Run Admin Procedure
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="form-horizontal voffset4" role="form">
                            <div className="fw-normal">
                                <div className="form-group">
                                    <label
                                        id="para-label"
                                        style={{
                                            display: 'inline-block',
                                            width: 'auto',
                                            marginRight: '5px',
                                            marginLeft: '125px',
                                        }}
                                    >
                                        Name:
                                    </label>

                                    {
                                        <label id="para-label">
                                            {data === undefined ? '' : data.ToolSPName}
                                        </label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label
                                        id="para-label"
                                        style={{
                                            display: 'inline-block',
                                            width: 'auto',
                                            marginRight: '5px',
                                            marginLeft: '125px',
                                        }}
                                    >
                                        Description:
                                    </label>
                                    {
                                        <label id="para-label">
                                            {data === undefined ? '' : data.ToolDescription}
                                        </label>
                                    }
                                </div>
                            </div>
                            {data.ParamList.map((item) => {
                                // Boolean
                                if (item.DataType === 3) {
                                    return (
                                        <div
                                            className="row justify-content-center"
                                            id="para-admin"
                                            key={item.Position}
                                        >
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={(e) =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`param_value_${item.Position}`}
                                                                        checked={paramValues[item.Position] === 1}
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                item.Position,
                                                                                e.target.checked
                                                                                    ? 1
                                                                                    : 0,
                                                                                true
                                                                            )
                                                                        }
                                                                    />    
                                                                     </div>  
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.ProperName}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                //DateTime
                                else if (item.DataType === 6) {
                                    return (
                                        <div
                                            className="row justify-content-center"
                                            id="para-admin"
                                            key={item.Position}
                                        >
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">                                                                
                                                                <DatePicker
                                                                dateFormat="MM/DD/YYYY h:mm a"
                                                                classes='custom-datepicker'
                                                                showIcon={false}
                                                                startingDate={
                                                                    startingDates[item.Position]
                                                                        ? moment(
                                                                              startingDates[item.Position],
                                                                              'MM/DD/YYYY h:mm aa'
                                                                          ).toDate()
                                                                        : null
                                                                }
                                                                setStartingDate={(newDate) =>
                                                                    handleDateChange(
                                                                        item.Position,
                                                                        newDate
                                                                    )
                                                                }
                                                                placeholder ='mm/dd/yyyy HH:MM'
                                                                inputClass='datepicker-input'
                                                                showTime={true}
                                                                interval={1}
                                                                onKeyDown={(e) => {
                                                                    e.preventDefault();
                                                                }}
                                                            />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.Name}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                
                                //Decimal
                                else if (item.DataType === 7) {
                                    return (
                                        <div className="row justify-content-center" id="para-admin">
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id={`param_value_${item.Position}`}
                                                                        maxLength={15}
                                                                        placeholder=""
                                                                        data-ng-trim="true"
                                                                        value={
                                                                            paramValues[
                                                                                item.Position
                                                                            ] || ''
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                item.Position,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.Name}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                // Double
                                else if (item.DataType === 8) {
                                    return (
                                        <div className="row justify-content-center" id="para-admin">
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id={`param_value_${item.Position}`}
                                                                        maxLength={15}
                                                                        placeholder=""
                                                                        data-ng-trim="true"
                                                                        //defaultValue={item.Value || ''}
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                item.Position,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={
                                                                            paramValues[
                                                                                item.Position
                                                                            ] || ''
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.Name.replace(/@/g, '')}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                //Int32
                                else if (item.DataType === 11) {
                                    return (
                                        <div className="row justify-content-center" id="para-admin">
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id={`param_value_${item.Position}`}
                                                                        maxLength={10}
                                                                        placeholder=""
                                                                        data-ng-trim="true"
                                                                        value={
                                                                            paramValues[
                                                                                item.Position
                                                                            ] || ''
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                item.Position,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.Name.replace(/@/g, '')}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                //Int64
                                else if (item.DataType === 12) {
                                    return (
                                        <div className="row justify-content-center" id="para-admin">
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id={`param_value_${item.Position}`}
                                                                        maxLength={10}
                                                                        placeholder=""
                                                                        data-ng-trim="true"
                                                                        value={
                                                                            paramValues[
                                                                                item.Position
                                                                            ] || ''
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                item.Position,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.ProperName}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                //AnsiString
                                else if (item.DataType === 0) {
                                    return (
                                        <div className="row justify-content-center" id="para-admin">
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                {!item.IsNull && (
                                                    <>
                                                        <div className="control-group">
                                                            <div
                                                                className="value-container"
                                                                style={{
                                                                    marginBottom: '20px',
                                                                    display: isChecked[
                                                                        item.Position
                                                                    ]
                                                                        ? 'none'
                                                                        : 'block',
                                                                }}
                                                            >
                                                                <label>Value</label>
                                                                <div className="controls">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id={`param_value_${item.Position}`}
                                                                        maxLength={1024}
                                                                        placeholder=""
                                                                        data-ng-trim="true"
                                                                        value={
                                                                            paramValues[
                                                                                item.Position
                                                                            ] || ''
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleInputChange(
                                                                                item.Position,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`valmsg_param_${item.Name.replace(/@/g, '')}`}
                                                            className="field-validation-error param-val-msg"
                                                        ></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                //String
                                else if (item.DataType === 16) {
                                    return (
                                        <div className="row justify-content-center" id="para-admin">
                                            <div className="col-sm-4">
                                                <label>{item.Name.replace(/@/g, '')}:</label>
                                            </div>
                                            <div className="col-sm-2" id={`check_${item.Position}`}>
                                                <div className="control-group">
                                                    <label>Leave Empty</label>
                                                    <div className="controls mb-5">
                                                        <input
                                                            type="checkbox"
                                                            id={`param_isnull_${item.Position}`}
                                                            data-related={`param_value_${item.Position}`}
                                                            checked={
                                                                checkAll ||
                                                                isChecked[item.Position] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(item.Position)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4" id={`check_${item.Position}`}>
                                                <div className="control-group">
                                                    <div
                                                        className="value-container"
                                                        style={{
                                                            marginBottom: '20px',
                                                            display: isChecked[item.Position]
                                                                ? 'none'
                                                                : 'block',
                                                        }}
                                                    >
                                                        <label>Value</label>
                                                        <div className="controls">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id={`param_value_${item.Position}`}
                                                                value={
                                                                    paramValues[item.Position] || ''
                                                                }
                                                                onChange={(e) =>
                                                                    handleInputChange(
                                                                        item.Position,
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                        <div className="form-group voffset5 row" style={{ marginTop: '10px' }}>
                            &nbsp;
                            
                            <div className="col-sm-1" style={{ marginLeft: '110px'}}>
                                <button
                                    type="button"
                                    className="ui-button app-button negative"
                                    id="checkall"
                                    onClick={handleCheckAll}
                                    style={{ display: data.ParamList && data.ParamList.length > 0 ? 'inline-block' : 'none' }}
                                >
                                    Check All
                                </button>
                            </div>
                            <div className="col-sm-4"
                            >
                                <button
                                    type="button"
                                    className="ui-button app-button negative"
                                    id="uncheckall"
                                    onClick={handleUncheckAll}
                                    style={{ display: data.ParamList && data.ParamList.length > 0 ? 'inline-block' : 'none' }}
                                >
                                    Uncheck All
                                </button>
                            </div>
                            <div className="col-sm-1">
                                <button
                                    type="button"
                                    className="app-button"
                                    id="idrun"
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        handleRun(Request)
                                    }}
                                >
                                    Run
                                </button>
                            </div>
                            <div className="col-sm-2">
                                <button
                                    type="button"
                                    className="ui-button app-button negative"
                                    id="cancelRunToolValue"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <div id="admintoolresult">
                       
                            {resultHtml &&
                                Object.keys(resultHtml).map((table, tableIndex) => (
                                    <div key={tableIndex}>
                                        {renderTable(resultHtml[table])}
                                    </div>
                                ))}
                            <div className="padding-top-large"></div>
                            <div className="padding-top-large"></div>
                        </div>
                    </div>
                </>
            )
        }
    }
}
export default RunAdminProcedure
